import { Component, effect, input, signal, ViewChild } from '@angular/core';
import { PatientTargetModel, TargetType } from '../../core/api/models';
import { GraphApiService, SupervisorApiService } from '../../core/api/services';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { Utils } from '../../core/utils';
import { PatientDataFacadeService } from '../../core/services/patient-data-facade.service';
@Component({
  selector: 'app-targets',
  templateUrl: './targets.component.html',
  styleUrl: './targets.component.css',
  standalone: false,
})
export class TargetsComponent {
  patientID = input.required<string>();

  isLoading: boolean = false;

  selectableTargets = signal<SelectItem[]>([]);
  selectedTargets = signal<PatientTargetModel[]>([]);

  constructor(
    private supervisorApiService: SupervisorApiService,
    private router: Router,
    private patientDataFacade: PatientDataFacadeService
  ) {
    effect(() => {
      if (this.patientID()) {
        this.loadData();
      } else {
        this.router.navigate(['/select-patient']);
      }
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.patientDataFacade
      .getTargets(Number(this.patientID()), { onlyActive: false })
      .subscribe(
        (targets) => {
          console.log(targets);
          this.selectableTargets.set(
            // filter out targets which cannot be used for graphs.
            targets
              .filter(
                (target) =>
                  target.TargetType == TargetType.DiscreteTrialTeaching ||
                  target.TargetType == TargetType.ConditionalDiscrimination ||
                  target.TargetType == TargetType.Echoic ||
                  target.TargetType == TargetType.Frequency ||
                  target.TargetType == TargetType.Duration ||
                  target.TargetType == TargetType.Quantity ||
                  target.TargetType == TargetType.FluencyRate ||
                  target.TargetType == TargetType.GroupedFrequency ||
                  target.TargetType == TargetType.TaskAnalysis ||
                  target.TargetType == TargetType.Toileting ||
                  target.TargetType == TargetType.WholePartialInterval ||
                  target.TargetType == TargetType.Currency
              )
              .map((target) => ({
                text: target.TargetName ? target.TargetName + ' (' + Utils.patientTargetTypeLabel(target?.TargetType!) + ')' : 'No Name For Target',
                value: target,
              }))
          );
          this.isLoading = false;
        },
        (error) => {
          console.error('Error fetching data', error);
          this.isLoading = false;
        }
      );
  }

  onTargetChange(event: MultiSelectChangeEvent) {
    if (!event.value) {
      return;
    }
  }
}
